import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconGoogle(rest) {
  return (
    <Icon viewBox="0 0 16 16" {...rest}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="m8.2868425 9.32113821v-1.91260162h6.6151095c.06467.33333333.098048.72764227.098048 1.15447154 0 1.43495935-.4026226 3.20934957-1.7001937 4.47357727-1.262107 1.2804878-2.8746834 1.9634146-5.01087768 1.9634146-3.95946952 0-7.28892862-3.1422764-7.28892862-7 0-3.85772358 3.3294591-7 7.28892862-7 2.19043358 0 3.75085678.83739837 4.92326028 1.92886179l-1.3851885 1.34959349c-.8407092-.76829268-1.97973472-1.36585365-3.5401579-1.36585365-2.89137238 0-5.15273432 2.2703252-5.15273432 5.08739837 0 2.8170732 2.26136194 5.0873984 5.15273432 5.0873984 1.8754284 0 2.9435256-.7337399 3.6277753-1.4004065.5549098-.5406504.9199821-1.3130082 1.0639249-2.36788621z"
      />
    </Icon>
  )
}
